import { HTMLAttributes } from 'react';
import styled from 'styled-components';
import { em } from 'modules/helpers/style';
import ThemeProvider from 'theming/ThemeProvider';
import { breakpoint, sizes } from 'variables';
import { Typography } from '../typography';
import type { TagProps } from './shared/types';

const StyledLabel = styled(Typography.Label)`
   display: inline-block;
   line-height: 1;
    && {
        display: grid;
        grid-template-columns: auto;
      
        ${breakpoint.up(sizes.sm)} {
            display: flex;
            flex-wrap: wrap;
        }
    }    
`;

const Wrapper = styled.div<{ $backgroundColor?: string; $textColor?: string }>`
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    border-radius: ${({ theme }) => theme.RadiusSmall};
    background-color: ${({ theme, $backgroundColor }) => ($backgroundColor ? $backgroundColor : theme.ColorBackgroundPrimary)};
    color: ${({ theme, $textColor }) => ($textColor ? $textColor : theme.ColorTextPrimary)};
    letter-spacing: ${em(0.2)};
    padding: 5px 4px;
`;

export default function Tag(props: TagProps): JSX.Element {
    const { text, className, as, variant = 'neutral', children } = props;
    const { backgroundColor, textColor } = typeof variant === 'object' ? variant : {};

    function Content() {
        return (
            <Wrapper className={className} as={as} $backgroundColor={backgroundColor} $textColor={textColor}>
                {children ? children : <StyledLabel size="S">{text}</StyledLabel>}
            </Wrapper>
        );
    }

    return typeof variant === 'string' ? (
        <ThemeProvider theme={variant}>
            <Content />
        </ThemeProvider>
    ) : (
        <Content />
    );
}
